import React, { useState, useEffect, useRef } from 'react';
import { useLanguage } from '../StoreContext/LanguageContext';
import apiService from '../config';
// import Navbar from '../Components/Navbar';

export default function PrivateObjection({ onSubmitSuccess, setSelectedComponent }) {
  const { language, translations } = useLanguage();
  const [formData, setFormData] = useState({
    projectName: '',
    objectionDate: '',
    objectionType: '',
    owner_name: '',
    owner_contact: '',
    representative_name: "",
    owner_email: '',
    owner_address: '',
    identity_proof_type: '',
    identity_proof_no: '',
    survey_no: '',
    affectedVillage: '',
    affectedTaluka: '',
    affectedDistrict: '',
    objectionCategory: '',
    objection_summary: '',
    objection_details: '',
    objectionCompensation: false,
    objectionMeasurement: false,
    objectionTrees: false,
    objectionStructures: false,
    objectionCrops: false,
    objectionWaterBodies: false,
    objectionTitle: false,
    objectionLivelihood: false,
    objectionPayment: false,
    Agriculture: false,
    NonAgriculture: false,
    AccurateLandRecords: false,
    objectionOther: '',
    recordedArea: '',
    claimedArea: '',
    areaUnit: 'sqm',
    recordedCompensation: '',
    expectedCompensation: '',
    numTreesRecorded: '',
    numTreesClaimed: '',
    treeDetails: '',
    minDate: '',
    maxDate: '',
    relationship_with_owner: "",
  });

  const [identityProofFile, setIdentityProofFile] = useState(null);
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [formStatus, setFormStatus] = useState({ show: false, type: '', message: '' });
  const [validationAttempted, setValidationAttempted] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const fileInputRef = useRef(null);
  const formRef = useRef(null);

  const objectionCategories = ['Encroachment', 'Compensation', 'Boundary Issue', 'Other'];
  const areaUnits = ['sqm', 'sqft', 'acres', 'hectares'];
  const [projectOptions, setProjectOptions] = useState([]);
  const [projectDeclarations, setProjectDeclarations] = useState({});
  const [projectOptionsMap, setProjectOptionsMap] = useState([]);

  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otpValue, setOtpValue] = useState('');
  const [otpErrors, setOtpErrors] = useState('');
  const [isVerifyingOtp, setIsVerifyingOtp] = useState(false);
  const [objectionId, setObjectionId] = useState(null);

  const [selectedObjection, setSelectedObjection] = useState(null);
  const [notification, setNotification] = useState({ show: false, type: '', message: '' });
  const [projectId, setProjectId] = useState('');

  const [showSurveyModal, setShowSurveyModal] = useState(true);
  const [surveyInput, setSurveyInput] = useState('');
  const [surveyError, setSurveyError] = useState('');
  const [isSurveyVerified, setIsSurveyVerified] = useState(false);
  const [aadharInput, setAadharInput] = useState('');

  const [surveyData, setSurveyData] = useState({});


  //prefields
  const [isLoadingProfile, setIsLoadingProfile] = useState(true);

  const formatDate = (dateStr) => {
    const [year, month, day] = dateStr.split('-');
    return `${day}/${month}/${year}`;
  };

  //Local storage
  const [submissionData, setSubmissionData] = useState(null);

  // CUSTOM POPUP STATES - Add these for consistent design
  const [customConfirm, setCustomConfirm] = useState({ show: false, title: '', message: '', onConfirm: null, onCancel: null });
  const [customAlert, setCustomAlert] = useState({ show: false, title: '', message: '', onClose: null });

  const proposalNoFromSession = sessionStorage.getItem('selectedProposalNo') || '';


  // Custom confirm function to replace window.confirm
  const showCustomConfirm = (message, onConfirm, onCancel = null) => {
    return new Promise((resolve) => {
      setCustomConfirm({
        show: true,
        title: 'Confirmation',
        message: message,
        onConfirm: () => {
          setCustomConfirm({ show: false, title: '', message: '', onConfirm: null, onCancel: null });
          if (onConfirm) onConfirm();
          resolve(true);
        },
        onCancel: () => {
          setCustomConfirm({ show: false, title: '', message: '', onConfirm: null, onCancel: null });
          if (onCancel) onCancel();
          resolve(false);
        }
      });
    });
  };

  // Custom alert function to replace window.alert
  const showCustomAlert = (message, title = 'Information', onClose = null) => {
    return new Promise((resolve) => {
      setCustomAlert({
        show: true,
        title: title,
        message: message,
        onClose: () => {
          setCustomAlert({ show: false, title: '', message: '', onClose: null });
          if (onClose) onClose();
          resolve();
        }
      });
    });
  };

  //Droup down Distict taluka village
  const [districts, setDistricts] = useState([]);
  const [talukas, setTalukas] = useState([]);
  const [villages, setVillages] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState('');
  const [selectedTaluka, setSelectedTaluka] = useState('');
  const [selectedVillage, setSelectedVillage] = useState('');
  const [loadingDistricts, setLoadingDistricts] = useState(false);
  const [loadingTalukas, setLoadingTalukas] = useState(false);
  const [loadingVillages, setLoadingVillages] = useState(false);

  useEffect(() => {
    const fetchDistricts = async () => {
      setLoadingDistricts(true);
      try {
        const response = await apiService.getDistricts();
        console.log('Districts response:', response); // Debug log

        // Your API service returns full response, so access response.data
        setDistricts(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.error("Failed to fetch districts:", error);
        setDistricts([]);
      } finally {
        setLoadingDistricts(false);
      }
    };

    fetchDistricts();
  }, []);

  const handleTalukaChange = (event) => {
    const selectedTalukaId = event.target.value; // Should be numeric ID like 3983
    setSelectedTaluka(selectedTalukaId);
    setVillages([]);
    setSelectedVillage('');
  };

  // Fix 2: Update the useEffect for fetching talukas
  useEffect(() => {
    const fetchTalukas = async () => {
      if (selectedDistrict) {
        setLoadingTalukas(true);
        try {
          const response = await apiService.getTalukas(selectedDistrict);
          console.log('Talukas response:', response); // Debug log

          // Your API service returns full response, so access response.data
          setTalukas(Array.isArray(response.data) ? response.data : []);
          setSelectedTaluka('');
          setVillages([]);
          setSelectedVillage('');
        } catch (error) {
          console.error("Failed to fetch talukas:", error);
          setTalukas([]);
        } finally {
          setLoadingTalukas(false);
        }
      } else {
        setTalukas([]);
        setSelectedTaluka('');
        setVillages([]);
        setSelectedVillage('');
      }
    };

    fetchTalukas();
  }, [selectedDistrict]);

  useEffect(() => {
    const fetchVillages = async () => {
      if (selectedDistrict && selectedTaluka) {
        setLoadingVillages(true);
        try {
          // Debug: Check what values are being passed
          console.log('Calling getVillages with distNo:', selectedDistrict, 'talukaNo:', selectedTaluka);

          const response = await apiService.getVillages(selectedDistrict, selectedTaluka);
          console.log('Villages response:', response); // Debug log

          setVillages(Array.isArray(response.data) ? response.data : []);
          setSelectedVillage('');
        } catch (error) {
          console.error("Failed to fetch villages:", error);
          setVillages([]);
        } finally {
          setLoadingVillages(false);
        }
      } else {
        setVillages([]);
        setSelectedVillage('');
      }
    };

    fetchVillages();
  }, [selectedDistrict, selectedTaluka]);

  useEffect(() => {
    const storedProjectId = sessionStorage.getItem('selectedProjectId');
    if (storedProjectId) {
      // Set the project ID in your form state
      setProjectId(storedProjectId);
      // Optionally clear it after using
      // sessionStorage.removeItem('selectedProjectId');
    }
  }, []);

  //prefields
  useEffect(() => {
    const fetchUserProfile = async () => {
      setIsLoadingProfile(true);
      try {
        const response = await apiService.getProfile();
        if (response.status === 200 && response.data) {
          const profileData = response.data;

          setFormData(prev => ({
            ...prev,
            owner_name: profileData.name || profileData.full_name || prev.owner_name,
            owner_email: profileData.email || prev.owner_email,
            owner_contact: profileData.mobile || profileData.phone || profileData.contact || prev.owner_contact,
            owner_address: profileData.address || prev.owner_address
          }));
        }
      } catch (error) {
        console.error("Failed to fetch user profile:", error.message);
      } finally {
        setIsLoadingProfile(false);
      }
    };

    fetchUserProfile();
  }, []);

  useEffect(() => {
    const today = new Date().toISOString().split('T')[0];
    const maxDate = new Date();
    maxDate.setDate(maxDate.getDate() + 60);
    const maxDateStr = maxDate.toISOString().split('T')[0];

    setFormData((prev) => ({
      ...prev,
      objectionDate: today,
      minDate: today,
      maxDate: maxDateStr
    }));
  }, []);

  // Show alert messages for 5 seconds then hide
  useEffect(() => {
    if (formStatus.show) {
      const timer = setTimeout(() => {
        setFormStatus({ ...formStatus, show: false });
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [formStatus]);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        setIsLoadingProfile(true);
        const response = await apiService.getAllProjects();

        console.log('API Response:', response);

        if (response.status === 200 && response.data) {
          const projectsData = Array.isArray(response.data) ? response.data : [response.data];

          const options = projectsData.map(project => ({
            label: project.project_name,
            value: project.project_id.toString() // Ensure string consistency
          }));

          console.log('Processed Options:', options);

          setProjectOptionsMap(options);
          setProjectOptions(options.map(p => p.label));

          // Handle project declarations
          const declarations = {};
          projectsData.forEach((project) => {
            declarations[project.project_name] = project.administrative_order_date || null;
          });
          setProjectDeclarations(declarations);
        }
      } catch (error) {
        console.error("Failed to fetch projects:", error.message);
      } finally {
        setIsLoadingProfile(false);
      }
    };

    fetchProjects();
  }, []); // Run only once on mount

  // 2. Fixed useEffect for handling pre-selected project
  useEffect(() => {
    // Only run if we have projects loaded AND no project is currently selected in form
    if (projectOptionsMap.length > 0 && !formData.projectName) {
      const selectedProjectId = sessionStorage.getItem('selectedProjectId');
      const selectedProjectName = sessionStorage.getItem('selectedProjectName');

      console.log('Session Storage Values:', { selectedProjectId, selectedProjectName });
      console.log('Project Options Map:', projectOptionsMap);

      // Handle cases where we have either ID or name (or both)
      if (selectedProjectId || selectedProjectName) {
        let projectExists = null;

        // First try to find by ID if available
        if (selectedProjectId) {
          projectExists = projectOptionsMap.find(option =>
            option.value === selectedProjectId || option.value === selectedProjectId.toString()
          );
        }

        // If not found by ID, try to find by name
        if (!projectExists && selectedProjectName) {
          projectExists = projectOptionsMap.find(option =>
            option.label === selectedProjectName
          );
        }

        console.log('Project Exists:', projectExists);

        if (projectExists) {
          // Auto-select the project in the form
          setFormData(prevData => ({
            ...prevData,
            projectName: projectExists.label,  // ✅ Fixed: Use 'projectName' instead of 'project'
          }));

          console.log(`Auto-selected project: ${projectExists.label}`);

          // Clear session storage ONLY after successful form update
          // setTimeout(() => {
          //   sessionStorage.removeItem('selectedProjectId');
          //   sessionStorage.removeItem('selectedProjectName');
          // }, 100); // Small delay to ensure form update completes

        } else {
          console.warn(`Project not found. ID: ${selectedProjectId}, Name: ${selectedProjectName}`);
          // Clear invalid session storage
          // sessionStorage.removeItem('selectedProjectId');
          // sessionStorage.removeItem('selectedProjectName');
        }
      }
    }
  }, [projectOptionsMap, formData.projectName]); // ✅ Fixed: Use 'projectName' instead of 'project'

  // Field validation
  const validateField = (name, value) => {
    let error = '';

    switch (name) {
      case 'projectName':
        if (!value) error = 'Project name is required';
        break;
      case 'objectionDate':
        if (!value) {
          error = 'Objection date is required';
        } else {
          const today = new Date().toISOString().split('T')[0];
          const maxDate = new Date();
          maxDate.setDate(maxDate.getDate() + 60);
          const maxDateStr = maxDate.toISOString().split('T')[0];

          if (value < today || value > maxDateStr) {
            error = `Date must be between today and ${maxDateStr} (60 days from today)`;
          }
        }
        break;
      case 'owner_name':
        if (!value) error = 'Name is required';
        else if (value.length < 3) error = 'Name must be at least 3 characters long';
        break;
      case 'objection_summary':
        if (!value) error = 'Summary is required';
        break;
      case 'owner_contact':
        if (!value) {
          error = 'Contact number is required';
        } else if (value.length !== 10) {
          error = 'Contact must be exactly 10 digits';
        } else if (!/^\d{10}$/.test(value)) {
          error = 'Contact must contain only numbers';
        }
        break;
      case 'owner_email':
        if (value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          error = 'Please enter a valid email address';
        }
        break;
      case 'owner_address':
        if (value && value.length < 10) {
          error = 'Please enter a complete address (min 10 characters)';
        }
        break;
      case 'identity_proof_type':
        if (!value) error = 'Please select an identity proof type';
        break;
      case 'identity_proof_no':
        if (!value) {
          error = 'Identity proof number is required';
        } else {
          // Validation based on proof type
          if (formData.identity_proof_type === 'Aadhaar Card (Front and Back)') {
            if (!/^\d{12}$/.test(value)) {
              error = 'Aadhaar number must be 12 digits';
            }
          } else if (formData.identity_proof_type === 'PAN Card') {
            if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(value)) {
              error = 'PAN number format is invalid';
            }
          } else if (formData.identity_proof_type === 'Voting Card') {
            if (!/^[A-Z]{3}\d{7}$/.test(value)) {
              error = 'Voter ID format is invalid';
            }
          } else if (formData.identity_proof_type === 'Driving License') {
            if (value.length < 8) {
              error = 'License number format is invalid';
            }
          }
        }
        break;
      case 'survey_no':
        if (value && !/^[A-Z0-9\/-]+$/.test(value)) {
          error = 'Please enter a valid survey number';
        }
        break;
      case 'recordedArea':
        if (formData.objectionMeasurement && !value) {
          error = 'Recorded area is required';
        } else if (value && (isNaN(value) || Number(value) <= 0)) {
          error = 'Please enter a valid area value';
        }
        break;
      case 'claimedArea':
        if (formData.objectionMeasurement && !value) {
          error = 'Claimed area is required';
        } else if (value && (isNaN(value) || Number(value) <= 0)) {
          error = 'Please enter a valid area value';
        }
        break;
      case 'recordedCompensation':
        if (formData.objectionCompensation && !value) {
          error = 'Recorded compensation is required';
        } else if (value && (isNaN(value) || Number(value) < 0)) {
          error = 'Please enter a valid amount';
        }
        break;
      case 'expectedCompensation':
        if (formData.objectionCompensation && !value) {
          error = 'Expected compensation is required';
        } else if (value && (isNaN(value) || Number(value) < 0)) {
          error = 'Please enter a valid amount';
        }
        break;
      case 'numTreesRecorded':
        if (formData.objectionTrees && !value) {
          error = 'Number of trees recorded is required';
        } else if (value && (isNaN(value) || Number(value) < 0 || !Number.isInteger(Number(value)))) {
          error = 'Please enter a valid whole number';
        }
        break;
      case 'numTreesClaimed':
        if (formData.objectionTrees && !value) {
          error = 'Number of trees claimed is required';
        } else if (value && (isNaN(value) || Number(value) < 0 || !Number.isInteger(Number(value)))) {
          error = 'Please enter a valid whole number';
        }
        break;
      case 'objection_summary':
        if (value && value.length > 500) {
          error = 'Summary should not exceed 500 characters';
        }
        break;
      case 'objection_details':
        if (value && value.length > 1000) {
          error = 'Details should not exceed 1000 characters';
        }
        break;
      default:
        break;
    }

    return error;
  };

  // Validate all form fields
  const validateForm = () => {
    const newErrors = {};

    // Validate each field
    Object.keys(formData).forEach(key => {
      const error = validateField(key, formData[key]);
      if (error) {
        newErrors[key] = error;
      }
    });

    // Special validations
    if (!identityProofFile) {
      newErrors.identityProofFile = 'Please upload an identity proof document';
    }

    // Check if any objection category is selected
    const anyObjectionSelected = formData.objectionCompensation ||
      formData.objectionMeasurement ||
      formData.objectionTrees ||
      formData.objectionStructures ||
      formData.objectionCrops ||
      formData.objectionWaterBodies ||
      formData.objectionTitle ||
      formData.objectionLivelihood ||
      formData.objectionPayment ||
      formData.Agriculture ||
      formData.NonAgriculture ||
      formData.AccurateLandRecords ||
      (formData.objectionOther && formData.objectionOther.trim() !== '');

    if (!anyObjectionSelected) {
      newErrors.objectionCategory = 'Please select at least one objection category';
    }

    return newErrors;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === 'owner_contact') {
      const onlyNums = value.replace(/\D/g, '');
      if (onlyNums.length <= 10) {
        setFormData((prev) => ({ ...prev, [name]: onlyNums }));
      }
    } else if (name === 'identityProofNo') {
  let sanitizedValue = value;

  if (formData.identity_proof_type === 'Aadhaar Card (Front and Back)') {
    sanitizedValue = value.replace(/\D/g, '').slice(0, 12); // Only digits, max 12
  } else if (formData.identity_proof_type === 'PAN Card') {
    sanitizedValue = value.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 10);
  } else if (formData.identity_proof_type === 'Voting Card') {
    sanitizedValue = value.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 10);
  } else if (formData.identity_proof_type === 'Driving License') {
    sanitizedValue = value.toUpperCase().replace(/[^A-Z0-9]/g, '');
  }

  setFormData((prev) => ({ ...prev, [name]: sanitizedValue }));

  if (touched[name] || validationAttempted) {
    const error = validateField(name, sanitizedValue);
    setErrors(prev => ({ ...prev, [name]: error }));
  }
} else {
  setFormData((prev) => ({
    ...prev,
    [name]: type === 'checkbox' ? checked : value
  }));
}


    // Validate on change for better UX
    if (touched[name] || validationAttempted) {
      const error = validateField(name, type === 'checkbox' ? checked : value);
      setErrors(prev => ({ ...prev, [name]: error }));
    }
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;

    // Mark field as touched
    setTouched(prev => ({ ...prev, [name]: true }));

    // Validate field
    const error = validateField(name, value);
    setErrors(prev => ({ ...prev, [name]: error }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setErrors(prev => ({ ...prev, identityProofFile: '' }));
    setTouched(prev => ({ ...prev, identityProofFile: true }));

    if (file) {
      // Check file type
      const validTypes = ['image/jpeg', 'image/png', 'application/pdf'];
      if (!validTypes.includes(file.type)) {
        setErrors(prev => ({
          ...prev,
          identityProofFile: 'File must be JPG, PNG or PDF format'
        }));
        fileInputRef.current.value = '';
        setIdentityProofFile(null);
        return;
      }

      if (file.size > 256 * 1024) { // 256KB in bytes
        setErrors(prev => ({
          ...prev,
          identityProofFile: 'File size exceeds 256KB limit'
        }));
        fileInputRef.current.value = '';
        setIdentityProofFile(null);
      } else {
        setIdentityProofFile(file);
      }
    } else {
      setIdentityProofFile(null);
    }
  };

  const scrollToFirstError = (errors) => {
    const firstErrorField = Object.keys(errors)[0];
    if (firstErrorField) {
      const errorElement = document.getElementById(firstErrorField);
      if (errorElement) {
        errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        errorElement.focus();
      }
    }
  };

  const handleReset = () => {
    // Reset the form to initial state
    const today = new Date().toISOString().split('T')[0];
    const maxDate = new Date();
    maxDate.setDate(maxDate.getDate() + 60);
    const maxDateStr = maxDate.toISOString().split('T')[0];

    setFormData({
      projectName: '',
      objectionDate: today,
      objectionType: '',
      owner_name: '',
      owner_contact: '',
      owner_email: '',
      owner_address: '',
      identity_proof_type: '',
      identity_proof_no: '',
      representative_name: '',
      relationship_with_owner: '',
      survey_no: '',
      affectedVillage: '',
      affectedTaluka: '',
      affectedDistrict: '',
      objectionCategory: '',
      objection_summary: '',
      objection_details: '',
      objectionCompensation: false,
      objectionMeasurement: false,
      objectionTrees: false,
      objectionStructures: false,
      objectionCrops: false,
      objectionWaterBodies: false,
      objectionTitle: false,
      objectionLivelihood: false,
      objectionPayment: false,
      Agriculture: false,
      NonAgriculture: false,
      AccurateLandRecords: false,
      objectionOther: '',
      recordedArea: '',
      claimedArea: '',
      areaUnit: 'sqm',
      recordedCompensation: '',
      expectedCompensation: '',
      numTreesRecorded: '',
      numTreesClaimed: '',
      treeDetails: '',
      minDate: today,
      maxDate: maxDateStr
    });

    setErrors({});
    setTouched({});
    setValidationAttempted(false);
    setIdentityProofFile(null);

    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }

    // Show success message
    setFormStatus({
      show: true,
      type: 'info',
      message: 'Form has been reset successfully.'
    });

    // Scroll to top
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const getProjectIdByName = (name) => {
    const project = projectOptionsMap.find(p => p.label === name);
    return project ? project.value : null;
  };

  const getSelectedObjectionCategory = (data) => {
    const categories = [];
    if (data.objectionCompensation) categories.push("Compensation Amount");
    if (data.objectionMeasurement) categories.push("Measurement Issues");
    if (data.objectionTrees) categories.push("Trees Assessment");
    if (data.objectionStructures) categories.push("Structures Assessment");
    if (data.objectionCrops) categories.push("Crops Assessment");
    if (data.objectionWaterBodies) categories.push("Water Bodies");
    if (data.objectionTitle) categories.push("Title/Ownership Issues");
    if (data.objectionLivelihood) categories.push("Livelihood Impact");
    if (data.objectionPayment) categories.push("Payment");
    if (data.Agriculture) categories.push("Agriculture");
    if (data.NonAgriculture) categories.push("Non-Agriculture");
    if (data.AccurateLandRecords) categories.push("Accurate Land Records");
    if (data.objectionOther && data.objectionOther.trim()) {
      categories.push(data.objectionOther.trim());
    }
    return categories.join(', ');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Set validation attempted to true to show all errors
    setValidationAttempted(true);

    // Mark all fields as touched for validation
    const allTouched = Object.keys(formData).reduce((touched, field) => {
      touched[field] = true;
      return touched;
    }, {});

    setTouched(allTouched);
    setTouched(prev => ({ ...prev, identityProofFile: true }));

    // Validate all fields
    const formErrors = validateForm();
    setErrors(formErrors);

    if (Object.keys(formErrors).length === 0) {
      setIsSubmitting(true);

      // Show loading message
      setFormStatus({
        show: true,
        type: 'loading',
        message: 'Processing your submission...'
      });

      try {
        // Store all form data in localStorage before OTP verification
        const dataToStore = {
          formData: { ...formData },
          projectId: getProjectIdByName(formData.projectName),
          objectionCategory: getSelectedObjectionCategory(formData),
          timestamp: new Date().toISOString()
        };

        localStorage.setItem('pendingObjectionData', JSON.stringify(dataToStore));

        // Store file separately if it exists
        if (identityProofFile) {
          const reader = new FileReader();
          reader.onload = function (e) {
            localStorage.setItem('pendingIdentityFile', JSON.stringify({
              name: identityProofFile.name,
              type: identityProofFile.type,
              size: identityProofFile.size,
              data: e.target.result
            }));
          };
          reader.readAsDataURL(identityProofFile);
        }

        console.log('✅ Form data stored in localStorage');

        // Hide loading message and show OTP popup
        setFormStatus({ show: false, type: '', message: '' });

        // Show popup asking if user wants to send OTP - REPLACED window.confirm with custom popup but SAME LOGIC
        const userConfirmed = await showCustomConfirm(
          `Ready to submit your objection!\nAn OTP will be sent to: ${formData.owner_email}\n\nClick OK to send OTP to your email.`
        );

        if (userConfirmed) {
          // Call OTP email API - EXACT SAME CODE AS ORIGINAL
          setFormStatus({
            show: true,
            type: 'loading',
            message: 'Sending OTP to your email...'
          });

          try {
            console.log('🔄 Calling OTP API with email:', formData.owner_email);

            const otpResponse = await apiService.getSendEmailOtpObjection(formData.owner_email);

            console.log('📨 OTP API Response:', otpResponse);

            // Hide loading status
            setFormStatus({ show: false, type: '', message: '' });

            // ✅ Store otpToken in localStorage ONLY if it exists
            if (otpResponse && otpResponse.otpToken) {
              localStorage.setItem('otpToken', otpResponse.otpToken);
              console.log('🔑 OTP Token stored in localStorage:', otpResponse.otpToken.substring(0, 20) + '...');

              // Show OTP modal since we have a valid token
              console.log('✅ Showing OTP modal with valid otpToken');
              setShowOtpModal(true);

            } else {
              // ❌ No otpToken received - show error and don't proceed
              console.error('❌ No otpToken received from OTP API');
              setFormStatus({
                show: true,
                type: 'error',
                message: 'Failed to generate OTP session. Please try again.'
              });
              return; // Exit early without showing modal
            }

            // Log success status
            if (otpResponse && otpResponse.success !== false) {
              console.log('✅ OTP API was successful');
            }

          } catch (otpError) {
            console.error('🚨 OTP sending error details:', otpError);

            let errorMessage = 'Failed to send OTP. Please try again.';

            if (otpError.message && otpError.message.includes('timeout')) {
              errorMessage = 'Request timed out. Please check your internet connection and try again.';
            } else if (otpError.response?.data) {
              errorMessage = otpError.response.data.message ||
                otpError.response.data.error ||
                `Server error (${otpError.response.status}): ${JSON.stringify(otpError.response.data)}`;
            } else if (otpError.response) {
              errorMessage = `HTTP ${otpError.response.status}: ${otpError.response.statusText || 'Server Error'}`;
            } else if (otpError.message) {
              errorMessage = otpError.message;
            }

            setFormStatus({
              show: true,
              type: 'error',
              message: errorMessage
            });
          }
        }
      } catch (error) {
        console.error('Submission error details:', error);

        let errorMessage = 'An error occurred while processing. Please try again.';
        if (error.message) {
          errorMessage = error.message;
        }

        setFormStatus({
          show: true,
          type: 'error',
          message: errorMessage
        });
      } finally {
        setIsSubmitting(false);
      }
    } else {
      scrollToFirstError(formErrors);

      // Show error message with specific field issues
      const errorFields = Object.keys(formErrors);
      const fieldList = errorFields.join(', ');

      setFormStatus({
        show: true,
        type: 'error',
        message: `Please correct the errors in the following fields: ${fieldList}`
      });
    }
  };

  const submitObjectionWithStoredData = async () => {
    try {
      // Get stored form data and submit objection
      const storedData = JSON.parse(localStorage.getItem('pendingObjectionData'));
      const storedFileData = localStorage.getItem('pendingIdentityFile');

      if (!storedData) {
        throw new Error('Stored objection data not found. Please try submitting again.');
      }

      console.log('Raw stored data:', storedData);

      // Check the structure of stored data - it might be nested differently
      // Try to access the form data from different possible structures
      let formDataSource;
      if (storedData.formData) {
        formDataSource = storedData.formData;
      } else if (storedData.data) {
        formDataSource = storedData.data;
      } else {
        // If data is stored at root level
        formDataSource = storedData;
      }

      console.log('Form data source:', formDataSource);

      // Helper function to safely get project ID
      // const getProjectId = () => {
      //   if (storedData.projectId) return storedData.projectId;
      //   if (formDataSource.projectId) return formDataSource.projectId;
      //   if (formDataSource.projectName) return getProjectIdByName(formDataSource.projectName);
      //   return null;
      // };

      const getProjectId = () => {
  return (
    storedData.projectId ||
    formDataSource.projectId ||
    getProjectIdByName(formDataSource.projectName) ||
    JSON.parse(localStorage.getItem('selectedProject'))?.project_id || // fallback
    ''
  );
};


      // Transform frontend field names to backend field names
      const transformedData = {
        project_id: getProjectId(),
        // proposal_id: sessionStorage.getItem("selectedProposalId") || "",
        proposal_id:
  sessionStorage.getItem("selectedProposalId") ||
  localStorage.getItem("currentProposalId") ||
  "",

        objection_date: formDataSource.objection_date || storedData.objection_date,
        owner_name: formDataSource.owner_name || storedData.owner_name,
        owner_contact: formDataSource.owner_contact || storedData.owner_contact,
        owner_email: formDataSource.owner_email || storedData.owner_email,
        owner_address: formDataSource.owner_address || storedData.owner_address,
        objection_summary: formDataSource.objection_summary || storedData.objection_summary,

        identity_proof_type: formDataSource.identity_proof_type || storedData.identity_proof_type,
        identity_proof_no: formDataSource.identity_proof_no || storedData.identity_proof_no,

        survey_no: formDataSource.survey_no || storedData.survey_no,
        village_name: formDataSource.village_name || storedData.village_name || selectedVillage,
        taluka_name: formDataSource.taluka_name || storedData.taluka_name || selectedTaluka,
        dist_name: formDataSource.dist_name || storedData.dist_name || selectedDistrict,

        objection_details: formDataSource.objection_details || storedData.objection_details || '',
        representative_name: formDataSource.representative_name || storedData.representative_name || '',
        relationship_with_owner: formDataSource.relationship_with_owner || storedData.relationship_with_owner || '',


        // Measurement details (only if measurement objection is true)
        recorded_area: formDataSource.recordedArea || storedData.recordedArea || null,
        claimed_area: formDataSource.claimedArea || storedData.claimedArea || null,
        // area_unit: formDataSource.areaUnit || storedData.areaUnit || null,

        // Compensation details (only if compensation objection is true)
        recorded_compensation: formDataSource.recordedCompensation || storedData.recordedCompensation || null,
        expected_compensation: formDataSource.expectedCompensation || storedData.expectedCompensation || null,

        objection_compensation: formDataSource.objectionCompensation || false,
        objection_measurement: formDataSource.objectionMeasurement || false,
        objection_trees: formDataSource.objectionTrees || false,
        objection_structures: formDataSource.objectionStructures || false,
        objection_crops: formDataSource.objectionCrops || false,
        objection_water_bodies: formDataSource.objectionWaterBodies || false,
        objection_title: formDataSource.objectionTitle || false,
        objection_livelihood: formDataSource.objectionLivelihood || false,
        objection_other: !!formDataSource.objectionOther, // true if a value is given


        // Tree details (only if trees objection is true)
        num_trees_recorded: formDataSource.numTreesRecorded || storedData.numTreesRecorded || null,
        num_trees_claimed: formDataSource.numTreesClaimed || storedData.numTreesClaimed || null,
        tree_details: formDataSource.treeDetails || storedData.treeDetails || null,

        // System fields
        supporting_documents: true,
        objection_status: 'Pending',
        hearing_required: true,
        // submission_timestamp: new Date().toISOString()
      };

      console.log('Transformed data for API:', transformedData);

      // Debug: Check which fields are still undefined
      const undefinedFields = Object.keys(transformedData).filter(key =>
        transformedData[key] === undefined || transformedData[key] === null
      );
      if (undefinedFields.length > 0) {
        console.warn('Fields with undefined/null values:', undefinedFields);
      }

      // Handle identity proof file
      let identityFile = null;
      if (storedFileData) {
        try {
          const fileInfo = JSON.parse(storedFileData);
          // Convert base64 back to file
          const response = await fetch(fileInfo.data);
          const blob = await response.blob();
          identityFile = new File([blob], fileInfo.name, { type: fileInfo.type });
          console.log('Identity file prepared:', identityFile.name, identityFile.size);
        } catch (fileError) {
          console.error('Error processing stored file:', fileError);
        }
      }

      // Create FormData for multipart submission
      const formDataToSend = new FormData();

      // Append all transformed data (excluding null/undefined values)
      Object.keys(transformedData).forEach(key => {
        const value = transformedData[key];
        if (value !== null && value !== undefined && value !== '') {
          // Convert boolean values to strings for FormData
          const formValue = typeof value === 'boolean' ? value.toString() : value;
          formDataToSend.append(key, formValue);
        }
      });

      // Append file if exists
      if (identityFile) {
        formDataToSend.append('identity_proof_file', identityFile);
      }

      console.log('FormData entries:');
      for (let pair of formDataToSend.entries()) {
        console.log(pair[0] + ': ' + pair[1]);
      }

      // Submit the objection with transformed data
      const objectionResponse = await apiService.postAddPrivateObjection(formDataToSend);

      console.log('Objection submission response:', objectionResponse);

      // Check if submission was successful (status 200 with message)
      if (objectionResponse && objectionResponse.status === 200) {
        // Clear localStorage
        // localStorage.removeItem('pendingObjectionData');
        // localStorage.removeItem('pendingIdentityFile');
        // localStorage.removeItem('otpToken');

        // Hide loading and close OTP modal
        setFormStatus({ show: false, type: '', message: '' });
        setShowOtpModal(false);

        // Get objection ID from response
        const objectionId = objectionResponse.objection_id || objectionResponse.id || Date.now();

        // Show success alert with the exact message from API - REPLACED alert with custom popup
        showCustomAlert(`✅ ${objectionResponse.message}\n\nDocuments uploaded: ${objectionResponse.documents?.identityProof ? 'Yes' : 'No'}`, 'Success');

        // Show success modal with objection details
        const refNumber = objectionId.toString().padStart(6, '0');
        const currentDate = formatDate(new Date().toISOString().split('T')[0]);

        setSubmissionData({ refNumber, date: currentDate });
        setShowSuccessModal(true);

        setFormStatus({
          show: true,
          type: 'success',
          message: `✅ ${objectionResponse.message} Reference No: #${refNumber}`
        });

        if (onSubmitSuccess) {
          onSubmitSuccess({
            ...formDataSource,
            refNumber,
            submissionDate: new Date().toISOString()
          });
        }

        setFormSubmitted(true);
        setTimeout(() => setFormSubmitted(false), 3000);

        // Reset OTP fields
        setOtpValue('');
        setObjectionId(null);
      } else {
        // Handle submission failure
        const errorMsg = objectionResponse?.message || objectionResponse?.error || 'Failed to submit objection. Please try again.';
        setFormStatus({
          show: true,
          type: 'error',
          message: errorMsg
        });
      }
    } catch (submissionError) {
      console.error('Objection submission error:', submissionError);

      let errorMessage = 'Failed to submit objection. Please try again.';

      if (submissionError.response?.status === 500) {
        errorMessage = 'Server error occurred during submission. Please try again.';
      } else if (submissionError.response?.data?.message) {
        errorMessage = submissionError.response.data.message;
      } else if (submissionError.message) {
        errorMessage = submissionError.message;
      }

      setFormStatus({
        show: true,
        type: 'error',
        message: errorMessage
      });
    }
  };

  const getStoredOtpToken = () => {
    const token = localStorage.getItem('otpToken');
    if (token) {
      console.log('🔑 Retrieved OTP token from localStorage:', token.substring(0, 20) + '...');
      return token;
    } else {
      console.warn('⚠️ No OTP token found in localStorage');
      return null;
    }
  };

  // Enhanced OTP verification with proper error handling
  const handleOtpVerification = async (otpValue) => {
    console.log('🔍 OTP Value received:', otpValue);
    try {
      const storedToken = getStoredOtpToken();

      if (!storedToken) {
        setFormStatus({
          show: true,
          type: 'error',
          message: 'OTP session expired. Please request a new OTP.'
        });
        return;
      }

      const verificationResponse = await apiService.postObjectionOtpVerify(
        formData.owner_email,
        otpValue,
        storedToken
      );

      if (verificationResponse === 200) {
        setOtpErrors('');
        // Close OTP modal immediately after successful verification
        setShowOtpModal(false);

        // OTP verified successfully - REPLACED alert with custom popup but SAME LOGIC
        showCustomAlert("OTP verified successfully", "Success");
        await submitObjectionWithStoredData();

        // Show success message with communication details
        const successMessage = `✅ Objection submitted successfully!\n\n` +
          `📧 Further updates and communication regarding your objection will be sent to:\n` +
          `• Email: ${formData.owner_email}\n` +
          `• SMS: ${formData.owner_contact}\n\n` +
          `Please keep checking your email and messages for important updates about your objection status.`;

        // REPLACED alert with custom popup but SAME LOGIC - Navigation happens only when OK is pressed
        showCustomAlert(successMessage, "Submission Complete", () => {
          // Navigate to homepage when OK is clicked
          window.location.href = '/';
        });
      } else {
        setOtpErrors('Invalid OTP. Please try again.'); 
      }
    } catch (error) {
      console.error('OTP verification failed:', error);
      setOtpErrors('OTP verification failed. Please try again.');
    }
  };

  // Add this useEffect to store the previous component when the form loads
  useEffect(() => {
    // Store the previous component if not already stored
    if (!sessionStorage.getItem('previousComponent')) {
      // You can get this from props or context if available
      const currentRoute = window.location.pathname || 'Dashboard';
      sessionStorage.setItem('previousComponent', currentRoute);
    }
  }, []);

  // Optional: Add a separate function to resend OTP if needed
  const handleResendOtp = async () => {
    try {
      setFormStatus({
        show: true,
        type: 'loading',
        message: 'Resending OTP...'
      });

      const otpResponse = await apiService.getSendEmailOtpObjection(formData.owner_email);

      if (otpResponse && otpResponse.otpToken) {
        localStorage.setItem('otpToken', otpResponse.otpToken);
        setOtpValue(''); // Clear current OTP input
        setOtpErrors('');
        setFormStatus({
          show: true,
          type: 'success',
          message: 'New OTP sent to your email successfully!'
        });
      } else {
        throw new Error('Failed to send OTP');
      }

    } catch (error) {
      console.error('Resend OTP error:', error);
      setFormStatus({
        show: true,
        type: 'error',
        message: 'Failed to resend OTP. Please try again.'
      });
    }
  };

  // Function for OTP input handling
  const handleOtpChange = (e) => {
    const value = e.target.value.replace(/\D/g, ''); // Only allow digits
    if (value.length <= 6) {
      setOtpValue(value);
      setOtpErrors(''); // Clear errors when user types
    }
  };

  const objectionTypes = ['Type 1', 'Type 2', 'Type 3'];
  const identityProofTypes = ['Aadhaar Card (Front and Back)', 'Voting Card', 'PAN Card', 'Driving License'];

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4">
      {/* <Navbar /> */}
      {/* <AdminDashboard/> */}
      <div className="max-w-5xl mx-auto bg-white rounded-xl shadow-lg overflow-hidden">
        <div className="bg-blue-900 py-4 px-6 flex items-center justify-between">
  {/* Left side: title and subtitle */}
  <div>
    <h1 className="text-2xl font-bold text-white">
      {translations[language].AffectedPersonObjection}
    </h1>
    <p className="text-blue-100 mt-1">
      {translations[language].Submityourprivateobjectiondetails}
    </p>
  </div>

  {/* Right side: Back button */}
  <button
    type="button"
    onClick={() => {
      if (setSelectedComponent) {
        setSelectedComponent('Dashboard'); // or any appropriate component
      } else {
        window.history.back();
      }
    }}
    className="inline-flex items-center px-4 py-2 bg-white hover:bg-gray-100 text-blue-900 font-medium rounded-md shadow transition duration-200"
  >
    ← {translations[language].back}
  </button>
</div>


        {/* Custom Confirm Modal - REPLACES window.confirm */}
        {customConfirm.show && (
          <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4 transition-opacity duration-300 ease-in-out">
            <div className="bg-white rounded-lg max-w-md w-full p-6 relative shadow-xl transform transition-all duration-300 ease-in-out scale-100">
              <div className="text-center mb-6">
                <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-blue-100 mb-4">
                  <svg className="h-10 w-10 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>

                <h2 className="text-2xl font-bold text-gray-800 mb-2">{customConfirm.title}</h2>
                <div className="text-gray-600 mb-4 whitespace-pre-line">
                  {customConfirm.message}
                </div>
              </div>

              <div className="flex gap-3">
                <button
                  onClick={customConfirm.onCancel}
                  className="flex-1 bg-gray-300 hover:bg-gray-400 text-gray-800 font-medium px-4 py-3 rounded-lg transition-colors duration-300 border border-gray-300"
                >
                  {translations[language].cancel}
                </button>
                <button
                  onClick={customConfirm.onConfirm}
                  className="flex-1 bg-blue-600 hover:bg-blue-700 text-white font-medium px-4 py-3 rounded-lg transition-colors duration-300 shadow-md hover:shadow-lg flex items-center justify-center"
                >
                  <svg className="h-5 w-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  {translations[language].ok}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Custom Alert Modal - REPLACES window.alert */}
        {customAlert.show && (
          <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4 transition-opacity duration-300 ease-in-out">
            <div className="bg-white rounded-lg max-w-md w-full p-6 relative shadow-xl transform transition-all duration-300 ease-in-out scale-100">
              <div className="text-center mb-6">
                <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100 mb-4">
                  <svg className="h-10 w-10 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>

                <h2 className="text-2xl font-bold text-gray-800 mb-2">{customAlert.title}</h2>
                <div className="text-gray-600 mb-4 whitespace-pre-line">
                  {customAlert.message}
                </div>
              </div>

              <div className="flex justify-center">
                <button
                  onClick={customAlert.onClose}
                  className="bg-blue-600 hover:bg-blue-700 text-white font-medium px-6 py-3 rounded-lg transition-colors duration-300 shadow-md hover:shadow-lg"
                >
                  {translations[language].ok}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Success Modal */}
        {showSuccessModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4 transition-opacity duration-300 ease-in-out">
            <div className="bg-white rounded-lg max-w-md w-full p-6 relative shadow-xl transform transition-all duration-300 ease-in-out">
              <button
                onClick={() => {
                  setShowSuccessModal(false);
                  handleReset();
                }}
                className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 transition-colors duration-200"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>

              <div className="text-center">
                <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100 mb-4">
                  <svg className="h-10 w-10 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                </div>

                <h2 className="text-2xl font-bold text-gray-800 mb-2">{translations[language].submissionsuccessful}</h2>
                <p className="text-gray-600 mb-4">{translations[language].yoh}</p>

                <div className="bg-gray-50 rounded-lg p-4 mb-4 text-left">
                  <p className="text-gray-700 mb-2">
                    <span className="font-semibold">{translations[language].referencenumber}:</span> #{submissionData?.refNumber}
                  </p>
                  <p className="text-gray-700">
                    <span className="font-semibold">{translations[language].submissiondate}:</span> {submissionData?.date}
                  </p>
                </div>

                <p className="text-sm text-gray-500 mb-6">
                  {translations[language].pkyr}
                </p>

                <button
                  onClick={() => {
                    setShowSuccessModal(false);
                    handleReset();
                  }}
                  className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium px-4 py-2 rounded-lg transition-colors duration-300"
                >
                  {translations[language].sao}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* OTP Modal */}
        {showOtpModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4 transition-opacity duration-300 ease-in-out">
            <div className="bg-white rounded-lg max-w-md w-full p-6 relative shadow-xl transform transition-all duration-300 ease-in-out">
              <div className="text-center">
                <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-blue-100 mb-4">
                  <svg className="h-10 w-10 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>

                <h2 className="text-2xl font-bold text-gray-800 mb-2">{translations[language].verifyYourEmail}</h2>
                <p className="text-gray-600 mb-4">
                  {translations[language].otpSentMessage}:
                </p>

                <div className="bg-gray-50 rounded-lg p-3 mb-4">
                  <p className="text-blue-600 font-semibold">{formData.owner_email}</p>
                </div>

                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {translations[language].enterOtp}
                  </label>
                  <input
                    type="text"
                    value={otpValue}
                    onChange={handleOtpChange}
                    placeholder="Enter 6-digit OTP"
                    className={`w-full px-4 py-3 text-center text-2xl font-mono tracking-widest border ${otpErrors ? 'border-red-500 bg-red-50' : 'border-gray-300'
                      } rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors`}
                    maxLength={6}
                    autoComplete="off"
                  />
                  {otpErrors && (
                    <p className="text-red-500 text-sm mt-2 flex items-center">
                      <svg className="h-4 w-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                      </svg>
                      {otpErrors}
                    </p>
                  )}
                </div>

                <p className="text-sm text-gray-500 mb-6">
                  {translations[language].checkEmailForOtp}
                </p>

                <div className="flex gap-3">
                  <button
                    onClick={() => {
                      setShowOtpModal(false);
                      setOtpValue('');
                      setOtpErrors('');
                      setObjectionId(null);
                    }}
                    className="flex-1 bg-gray-300 hover:bg-gray-400 text-gray-800 font-medium px-4 py-2 rounded-lg transition-colors duration-300"
                    disabled={isVerifyingOtp}
                  >
                    {translations[language].cancel}
                  </button>
                  <button
                    onClick={() => handleOtpVerification(otpValue)}
                    disabled={isVerifyingOtp || !otpValue.trim()}
                    className={`flex-1 ${isVerifyingOtp || !otpValue.trim()
                      ? 'bg-blue-400 cursor-not-allowed'
                      : 'bg-blue-600 hover:bg-blue-700'
                      } text-white font-medium px-4 py-2 rounded-lg transition-colors duration-300 flex items-center justify-center`}
                  >
                    {isVerifyingOtp ? (
                      <>
                        <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        {translations[language].verifying}
                      </>
                    ) : (
                      <span>{translations[language].verifyOtp}</span>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Alert Messages (for errors and non-success states) */}
        {formStatus.show && formStatus.type !== 'success' && (
          <div className={`p-4 mx-6 mt-6 rounded-lg border ${formStatus.type === 'error' ? 'bg-red-50 border-red-200 text-red-800' :
            formStatus.type === 'loading' ? 'bg-blue-50 border-blue-200 text-blue-800' :
              'bg-gray-50 border-gray-200 text-gray-800'
            }`}>
            <div className="flex items-start">
              <div className="flex-shrink-0">
                {formStatus.type === 'error' && (
                  <svg className="h-5 w-5 text-red-500" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                  </svg>
                )}
                {formStatus.type === 'loading' && (
                  <svg className="animate-spin h-5 w-5 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                )}
                {formStatus.type === 'info' && (
                  <svg className="h-5 w-5 text-blue-500" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v4a1 1 0 102 0V7zm-1 8a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
                  </svg>
                )}
              </div>
              <div className="ml-3">
                <p className="font-medium">{formStatus.message}</p>
              </div>
              <div className="ml-auto pl-3">
                <div className="-mx-1.5 -my-1.5">
                  <button
                    type="button"
                    onClick={() => setFormStatus({ ...formStatus, show: false })}
                    className={`inline-flex rounded-md p-1.5 focus:outline-none focus:ring-2 focus:ring-offset-2 ${formStatus.type === 'error' ? 'bg-red-50 text-red-500 hover:bg-red-100 focus:ring-red-600' :
                      'bg-blue-50 text-blue-500 hover:bg-blue-100 focus:ring-blue-600'
                      }`}
                  >
                    <span className="sr-only">{translations[language].dismiss}</span>
                    <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {showSurveyModal && !isSurveyVerified && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
              <h2 className="text-xl font-bold mb-4">{translations[language].verifyOwnerDetails}</h2>

              <label className="block text-sm font-medium mb-1">{translations[language].surveyNumber}</label>
              <input
                type="text"
                className="w-full border px-3 py-2 rounded mb-3"
                placeholder="e.g. 127/A"
                value={surveyInput}
                onChange={(e) => setSurveyInput(e.target.value)}
              />

              <label className="block text-sm font-medium mb-1">{translations[language].aadhaarNumber}</label>
              <input
                type="text"
                className="w-full border px-3 py-2 rounded mb-2"
                placeholder="Enter 12-digit Aadhaar number"
                value={aadharInput}
                onChange={(e) => setAadharInput(e.target.value.replace(/\D/g, '').slice(0, 12))}
              />

              {surveyError && <p className="text-sm text-red-500">{surveyError}</p>}

              <div className="flex justify-end space-x-2 mt-4">
                {/* <button
                  className="bg-gray-300 px-4 py-2 rounded"
                  onClick={() => {
                    setShowSurveyModal(false);  // Hide modal
                    setSurveyError('');
                  }}
                >
                  Close
                </button> */}

                <button
                className="bg-gray-300 hover:bg-gray-400 text-gray-800 px-4 py-2 rounded"
                onClick={() => setShowSurveyModal(false)}
              >
                {translations[language].cancel}
              </button>

                <button
                  className="bg-blue-600 text-white px-4 py-2 rounded"
                  onClick={async () => {
                    if (!surveyInput || !aadharInput || aadharInput.length !== 12) {
                      setSurveyError('Please enter valid Survey No and 12-digit Aadhaar No');
                      return;
                    }

                    try {
                      setSurveyError('');
                      const selectedProposalId =
                      sessionStorage.getItem("selectedProposalId") ||
                      localStorage.getItem("currentProposalId") ||
                      '';

                    const selectedProjectId =
                      sessionStorage.getItem("selectedProjectId") ||
                      JSON.parse(localStorage.getItem("selectedProject"))?.project_id ||
                      '';


                      const response = await apiService.getVerifyOwnerSurveyNo(
                        surveyInput,
                        aadharInput,
                        selectedProjectId,
                        selectedProposalId
                      );


                      if (response?.verify) {
                        setIsSurveyVerified(true);
                        setFormData(prev => ({
                          ...prev,
                          survey_no: surveyInput,
                          identity_proof_type: 'Aadhaar Card (Front and Back)',
                          identity_proof_no: aadharInput,
                          owner_name: response.data.owner_name,
                          owner_contact: response.data.owner_contact,
                          owner_email: response.data.owner_email,
                          owner_address: response.data.owner_address,
                        }));
                        setSurveyData(response.data);
                        setShowSurveyModal(false);
                      } else {
                        alert(response.message);
                        // setSurveyError(response.message);
                      }
                    } catch (error) {
                      console.error(error);
                      setSurveyError('Error verifying details. Please try again.');
                    }
                  }}
                >
                  {translations[language].verify}
                </button>
              </div>
            </div>
          </div>
        )}


        {/* Main Form */}
        {isSurveyVerified && (
          <form ref={formRef} onSubmit={handleSubmit} className="p-6 space-y-8">
            {/* Form-level error message */}
            {Object.keys(errors).length > 0 && validationAttempted && (
              <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                <div className="flex items-start">
                  <div className="flex-shrink-0 text-red-500">
                    <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div className="ml-3">
                    <h3 className="text-red-800 font-medium">{translations[language].pctfe}</h3>
                    <div className="mt-2 text-sm text-red-700">
                      <ul className="list-disc pl-5 space-y-1">
                        {Object.keys(errors).map((key) => (
                          <li key={key}>{errors[key]}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Objection Info */}
            <FormSection title={translations[language].basicInformation} step={1}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <Select
                  label={translations[language].projectName}
                  name="projectName"
                  options={projectOptions}
                  value={formData.projectName}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.projectName && errors.projectName}
                  required
                />

                <Input
            label={translations[language].proposalNo}
            type="text"
            id="proposalNo"
            name="proposalNo"
            value={proposalNoFromSession}
            disabled
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm bg-gray-100"

            />

                <Input
                  label={translations[language].objectionDate}
                  name="objectionDate"
                  type="text"
                  placeholder="DD/MM/YYYY"
                  value={formatDate(formData.objectionDate)}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.objectionDate && errors.objectionDate}
                  required
                  min={formData.minDate}
                  max={formData.maxDate}
                  disabled
                  helpText="Select date within 60 days from today"
                />
              </div>
            </FormSection>

            {/* Objector Details */}
            <FormSection title={translations[language].ownerInformation} step={2}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <Input
                  label={translations[language].ownerName}
                  name="owner_name"
                  value={formData.owner_name || ''} // fallback to empty string to avoid "undefined"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.owner_name && errors.owner_name}
                  required
                  disabled={isLoadingProfile}
                  placeholder={isLoadingProfile ? <span>{translations[language].loading}</span> : <span>{translations[language].enterYourName}</span>}
                />

                <PhoneInput
                  label={translations[language].contact}
                  name="owner_contact"
                  value={formData.owner_contact}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.owner_contact && errors.owner_contact}
                  required
                  disabled={isLoadingProfile}
                />

                <Input
                  label={translations[language].email}
                  name="owner_email"
                  type="email"
                  value={formData.owner_email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.owner_email && errors.owner_email}
                  // disabled={isLoadingProfile}
                  placeholder={isLoadingProfile ? "Loading..." : "Enter your email"}
                />
                <Input
                  label={translations[language].address}
                  name="owner_address"
                  value={formData.owner_address}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.owner_address && errors.owner_address}
                />
                <Textarea
                  label={translations[language].objectionSummary}
                  name="objection_summary"
                  value={formData.objection_summary}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.objection_summary && errors.objection_summary}
                  rows={3}
                  maxLength={500}
                  helpText="Brief summary of your objection (max 500 characters)"
                />
                <Textarea
                  label={translations[language].objectionDetails}
                  name="objection_details"
                  value={formData.objection_details}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.objection_details && errors.objection_details}
                  rows={5}
                  maxLength={1000}
                  helpText="Detailed description of your objection (max 1000 characters)"
                  required
                />
              </div>
            </FormSection>

            {/* Identity Proof */}
            <FormSection title={translations[language].identityProof} step={3}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <Select
                  label={translations[language].identityProofType}
                  name="identity_proof_type"
                  options={identityProofTypes}
                  value={formData.identity_proof_type}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.identity_proof_type && errors.identity_proof_type}
                  required
                />
                <Input
                  label={translations[language].identityProofNumber}
                  name="identity_proof_no"
                  value={surveyData.identity_proof_no}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.identity_proof_no && errors.identity_proof_no}
                  required
                  helpText={
                    formData.identity_proof_type === 'Aadhaar Card (Front and Back)' ? 'Enter 12 digit Aadhaar number' :
                      formData.identity_proof_type === 'PAN Card' ? 'Format: ABCDE1234F' :
                        formData.identity_proof_type === 'Voting Card' ? 'Format: ABC1234567' :
                          formData.identity_proof_type === 'Driving License' ? 'Enter driving license number' : null
                  }
                />
                <div className="flex flex-col md:col-span-2">
                  <label className="text-sm font-medium text-gray-700 mb-1.5">
                    {translations[language].uploadProof} <span className="text-red-500 ml-1">*</span>
                    <span className="text-xs text-gray-500 ml-2">({translations[language].maxsize})</span>
                  </label>
                  <div className={`border ${touched.identityProofFile && errors.identityProofFile ? 'border-red-500 bg-red-50' : 'border-gray-300'} rounded-lg p-4 transition-colors`}>
                    <input
                      id="identityProofFile"
                      type="file"
                      ref={fileInputRef}
                      onChange={handleFileChange}
                      accept=".jpg,.jpeg,.png,.pdf"
                      className="w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100 focus:outline-none"
                      required
                    />
                    {touched.identityProofFile && errors.identityProofFile ? (
                      <p className="text-red-500 text-sm mt-1">
                        <svg className="inline-block h-4 w-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                        </svg>
                        {errors.identityProofFile}
                      </p>
                    ) : identityProofFile ? (
                      <p className="text-green-600 text-sm mt-1">
                        <svg className="inline-block h-4 w-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                        </svg>
                        {translations[language].fileuploaded}: {identityProofFile.name} ({Math.round(identityProofFile.size / 1024)} {translations[language].KB})
                      </p>
                    ) : null}
                  </div>
                </div>
              </div>
            </FormSection>

            {/* Representative Details */}
            <FormSection title={translations[language].representativeDetails} step={4}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <Input
                  label={translations[language].representativeName}
                  name="representative_name"
                  value={formData.representative_name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.representative_name && errors.representative_name}
                />
                <Input
                  label={translations[language].relationshipWithOwner}
                  name="relationship_with_owner"
                  value={formData.relationship_with_owner}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.relationship_with_owner && errors.relationship_with_owner}
                />
              </div>
            </FormSection>

            {/* Affected Area */}
            <FormSection title={translations[language].LandDetails} step={5}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <Input
                  label={translations[language].surveyNo}
                  name="survey_no"
                  value={formData.survey_no}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.survey_no && errors.survey_no}
                />

                <div className="flex-1 min-w-[200px]">
                  <label className="block text-sm font-medium text-gray-700 mb-1">{translations[language].district}</label>
                  <select
                    value={selectedDistrict}
                    onChange={(e) => setSelectedDistrict(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    disabled={loadingDistricts}
                    required
                  >
                    <option value="">
                      {loadingDistricts ? <span>{translations[language].loadingDistricts}</span> :<span>{translations[language].selectDistrict}</span>}
                    </option>
                    {Array.isArray(districts) && districts.map(d => (
                      <option key={d.dist_name} value={d.dist_name}>
                        {d.dist_name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="flex-1 min-w-[200px]">
                  <label className="block text-sm font-medium text-gray-700 mb-1">{translations[language].taluka}</label>
                  <select
                    value={selectedTaluka}
                    onChange={(e) => setSelectedTaluka(e.target.value)}
                    disabled={!selectedDistrict || loadingTalukas}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100"
                    required
                  >
                    <option value="">
                      {loadingTalukas ? <span>{translations[language].loadingTalukas}</span> :<span>{translations[language].selectTaluka}</span>}
                    </option>
                    {talukas.map(t => (
                      <option key={t.taluka_name} value={t.taluka_name}>
                        {t.taluka_name}
                      </option>
                    ))}
                  </select>
                  {loadingTalukas && (
                    <div className="text-xs text-blue-600 mt-1">{translations[language].loadingTalukas}</div>
                  )}
                </div>

                <div className="flex-1 min-w-[200px]">
                  <label className="block text-sm font-medium text-gray-700 mb-1">{translations[language].village}</label>
                  <select
                    value={selectedVillage}
                    onChange={(e) => setSelectedVillage(e.target.value)}
                    disabled={!selectedTaluka || loadingVillages}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100"
                    required
                  >
                    <option value="">
                      {loadingVillages ? <span>{translations[language].loadingVillages}</span> : <span>{translations[language].selectVillage}</span>}
                    </option>
                    {villages.map(v => (
                      <option key={v.village_name} value={v.village_name}>{v.village_name}</option>
                    ))}
                  </select>
                  {loadingVillages && (
                    <div className="text-xs text-blue-600 mt-1">{translations[language].loadingVillages}</div>
                  )}
                </div>
              </div>
            </FormSection>

            {/* Objection Categories */}
            <FormSection title={translations[language].objectionCategories} step={6}>
              <div id="objectionCategory">
                <p className="text-sm text-gray-600 mb-3">{translations[language].psalo || 'Please select at least one objection category:'}:</p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <Checkbox
                    label={translations[language].compensationAmount}
                    name="objectionCompensation"
                    checked={formData.objectionCompensation}
                    onChange={handleChange}
                  />
                  <Checkbox
                    label={translations[language].payment}
                    name="objectionPayment"
                    checked={formData.objectionPayment}
                    onChange={handleChange}
                  />
                  <Checkbox
                    label={translations[language].agriculture}
                    name="Agriculture"
                    checked={formData.Agriculture}
                    onChange={handleChange}
                  />
                  <Checkbox
                    label={translations[language].nonAgriculture}
                    name="NonAgriculture"
                    checked={formData.NonAgriculture}
                    onChange={handleChange}
                  />
                  <Checkbox
                    label={translations[language].accurateLandRecords}
                    name="AccurateLandRecords"
                    checked={formData.AccurateLandRecords}
                    onChange={handleChange}
                  />
                  <Checkbox
                    label={translations[language].measurementIssues}
                    name="objectionMeasurement"
                    checked={formData.objectionMeasurement}
                    onChange={handleChange}
                  />
                  <Checkbox
                    label={translations[language].treesAssessment}
                    name="objectionTrees"
                    checked={formData.objectionTrees}
                    onChange={handleChange}
                  />
                  <Checkbox
                    label={translations[language].structuresAssessment}
                    name="objectionStructures"
                    checked={formData.objectionStructures}
                    onChange={handleChange}
                  />
                  <Checkbox
                    label={translations[language].cropsAssessment}
                    name="objectionCrops"
                    checked={formData.objectionCrops}
                    onChange={handleChange}
                  />
                  <Checkbox
                    label={translations[language].waterBodies}
                    name="objectionWaterBodies"
                    checked={formData.objectionWaterBodies}
                    onChange={handleChange}
                  />
                  <Checkbox
                    label={translations[language].titleOwnershipIssues}
                    name="objectionTitle"
                    checked={formData.objectionTitle}
                    onChange={handleChange}
                  />
                  <Checkbox
                    label={translations[language].livelihoodImpact}
                    name="objectionLivelihood"
                    checked={formData.objectionLivelihood}
                    onChange={handleChange}
                  />
                </div>
                <div className="mt-4">
                  <Input
                    label={translations[language].otherObjection}
                    name="objectionOther"
                    value={formData.objectionOther}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.objectionOther && errors.objectionOther}
                  />
                </div>
                {touched.objectionCategory && errors.objectionCategory && (
                  <p className="text-red-500 text-sm mt-2">
                    <svg className="inline-block h-4 w-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                    </svg>
                    {errors.objectionCategory}
                  </p>
                )}
              </div>
            </FormSection>

            {/* Measurement Details - Conditional rendering */}
            {formData.objectionMeasurement && (
              <FormSection title={translations[language].MeasurementDetails} step={7}>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <Input
                    label={translations[language].recordedArea}
                    name="recordedArea"
                    type="number"
                    value={formData.recordedArea}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.recordedArea && errors.recordedArea}
                    required
                  />
                  <Input
                    label={translations[language].claimedArea}
                    name="claimedArea"
                    type="number"
                    value={formData.claimedArea}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.claimedArea && errors.claimedArea}
                    required
                  />
                  <Select
                    label={translations[language].areaUnit}
                    name="areaUnit"
                    options={areaUnits}
                    value={formData.areaUnit}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.areaUnit && errors.areaUnit}
                    required
                  />
                </div>
              </FormSection>
            )}

            {/* Compensation Details - Conditional rendering */}
            {formData.objectionCompensation && (
              <FormSection title={translations[language].compensationDetails} step={formData.objectionMeasurement ? 8 : 7}>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <Input
                    label={translations[language].recordedCompensation}
                    name="recordedCompensation"
                    type="number"
                    value={formData.recordedCompensation}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.recordedCompensation && errors.recordedCompensation}
                    required
                  />
                  <Input
                    label={translations[language].expectedCompensation}
                    name="expectedCompensation"
                    type="number"
                    value={formData.expectedCompensation}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.expectedCompensation && errors.expectedCompensation}
                    required
                  />
                </div>
              </FormSection>
            )}

            {/* Tree Details - Conditional rendering */}
            {formData.objectionTrees && (
              <FormSection title="Tree Details" step={6 + (formData.objectionMeasurement ? 1 : 0) + (formData.objectionCompensation ? 1 : 0) + 1}>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <Input
                    label={translations[language].numberOfTreesRecorded}
                    name="numTreesRecorded"
                    type="number"
                    value={formData.numTreesRecorded}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.numTreesRecorded && errors.numTreesRecorded}
                    required
                  />
                  <Input
                    label={translations[language].numberOfTreesClaimed}
                    name="numTreesClaimed"
                    type="number"
                    value={formData.numTreesClaimed}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.numTreesClaimed && errors.numTreesClaimed}
                    required
                  />
                  <div className="md:col-span-2">
                    <Textarea
                      label={translations[language].treeDetails}
                      name="treeDetails"
                      value={formData.treeDetails}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.treeDetails && errors.treeDetails}
                    />
                  </div>
                </div>
              </FormSection>
            )}

            {/* Submit and Reset Buttons */}
            <div className="flex justify-center pt-4 space-x-4">
              <button
                type="button"
                onClick={handleReset}
                className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-medium px-6 py-3 rounded-lg transition-colors duration-300 shadow-md hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-opacity-50"
              >
                {translations[language].reset}
              </button>
              <button
                type="submit"
                className={`${isSubmitting ? 'bg-blue-400 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'} text-white font-medium px-8 py-3 rounded-lg transition-colors duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-1 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 flex items-center`}
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <>
                    <svg className="animate-spin -ml-1 mr-2 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    {translations[language].Processing}...
                  </>
                ) : 'Submit Objection'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div >
  );
}

// Form Section Component
function FormSection({ children, title, step }) {
  return (
    <div className="bg-white p-5 rounded-lg border border-gray-200 shadow-sm">
      <h2 className="text-xl font-semibold mb-4 text-gray-800 flex items-center">
        <span className="bg-blue-600 text-white rounded-full w-7 h-7 flex items-center justify-center mr-2 text-sm">{step}</span>
        {title}
      </h2>
      {children}
    </div>
  );
}

// Input Component with error handling
function Input({ label, name, value, onChange, onBlur, type = "text", error, required = false, helpText, min, max, disabled = false, placeholder }) {
  return (
    <div className="flex flex-col">
      <label htmlFor={name} className="text-sm font-medium text-gray-700 mb-1.5">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <input
        id={name}
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        required={required}
        min={min}
        max={max}
        disabled={disabled}
        placeholder={placeholder}
        className={`border ${error ? 'border-red-500 bg-red-50' : 'border-gray-300'} rounded-lg px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors`}
      />
      {error ? (
        <p className="text-red-500 text-sm mt-1">{error}</p>
      ) : helpText ? (
        <p className="text-gray-500 text-sm mt-1">{helpText}</p>
      ) : null}
    </div>
  );
}

// Phone Input with +91 and error handling
function PhoneInput({ label, name, value, onChange, onBlur, error, required = true }) {
  return (
    <div className="flex flex-col">
      <label htmlFor={name} className="text-sm font-medium text-gray-700 mb-1.5">
        {label} (10-digit)
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <div className={`flex items-center border ${error ? 'border-red-500 bg-red-50' : 'border-gray-300'} rounded-lg px-4 py-2.5 focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-transparent transition-colors`}>
        <span className="text-gray-500 mr-2 font-medium">+91</span>
        <input
          id={name}
          type="text"
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          required={required}
          className="w-full outline-none bg-transparent"
          placeholder="Enter mobile number"
          maxLength={10}
          pattern="[0-9]{10}"
        />
      </div>
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
}

// Textarea Component with error handling
function Textarea({ label, name, value, onChange, onBlur, error, rows = 4, required = false, maxLength, helpText }) {
  const charsRemaining = maxLength ? maxLength - (value?.length || 0) : null;
  const { language, translations } = useLanguage();

  return (
    <div className="flex flex-col">
      <label htmlFor={name} className="text-sm font-medium text-gray-700 mb-1.5">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <textarea
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        rows={rows}
        required={required}
        maxLength={maxLength}
        className={`border ${error ? 'border-red-500 bg-red-50' : 'border-gray-300'} rounded-lg px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors`}
      />
      <div className="flex justify-between mt-1">
        {error ? (
          <p className="text-red-500 text-sm">{error}</p>
        ) : helpText ? (
          <p className="text-gray-500 text-sm">{helpText}</p>
        ) : <span></span>}

        {maxLength && (
          <p className={`text-sm ${charsRemaining < maxLength * 0.1 ? 'text-red-500' : 'text-gray-500'}`}>
            {charsRemaining} {translations[language].charactersRemaining}
          </p>
        )}
      </div>
    </div>
  );
}

// Dropdown Select Component with error handling
function Select({ label, name, value, onChange, onBlur, error, options, required = false, helpText }) {
  return (
    <div className="flex flex-col">
      <label htmlFor={name} className="text-sm font-medium text-gray-700 mb-1.5">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <select
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        required={required}
        className={`border ${error ? 'border-red-500 bg-red-50' : 'border-gray-300'} rounded-lg px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors bg-white`}
      >
        <option value="">Select {label}</option>
        {options.map((opt, idx) => (
          <option key={idx} value={opt}>{opt}</option>
        ))}
      </select>
      {error ? (
        <p className="text-red-500 text-sm mt-1">{error}</p>
      ) : helpText ? (
        <p className="text-gray-500 text-sm mt-1">{helpText}</p>
      ) : null}
    </div>
  );
}

// Checkbox Component
function Checkbox({ label, name, checked, onChange }) {
  return (
    <div className="flex items-center">
      <input
        id={name}
        name={name}
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className="h-5 w-5 text-blue-600 focus:ring-blue-500 border-gray-300 rounded transition-colors"
      />
      <label htmlFor={name} className="ml-2 block text-sm text-gray-700">
        {label}
      </label>
    </div>
  );
}